export enum SortDirection {
    ASC,
    DESC
}

export type SortConfig = {
    key: string,
    direction?: SortDirection
}
